import register from '../../util/init'
import {VideoPlayer} from '../videoplayer'

class initPage {
  constructor (container) {
    this.container = container // main > article
    this.videoInstances = []

    // hijack the 'features' click so it triggers a historyback action
    const backLink = document.querySelector('.back')

    if (window.document.referrer &&
        window.document.referrer === `${window.location.origin}/features/`) {
      backLink.addEventListener('click', (e) => {
        e.preventDefault()
        window.history.back()
      })
    }

    this.container.querySelectorAll('.video-player').forEach((videoPlayer) => {
      this.videoInstances.push(new VideoPlayer(videoPlayer))
    })
  }
}
register('.feature-content', initPage)



// WEBPACK FOOTER //
// ./assets/j/src/features/feature.js